export const arrayMax = data => Math.max(...data);